module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"TodoStatistic":"Todo statistic","InTheLast30Days":"In the last 30 days"},"vi":{"TodoStatistic":"Thống kê công việc","InTheLast30Days":"Trong 30 ngày gần nhất"}}')
  delete Component.options._Ctor
}
